import { useI18n } from "../i18n/LanguageContext";
import { IMAGES } from "../data/mediaAssets";
import { useReveal } from "../hooks/useReveal";

const About = () => {
    const { t } = useI18n();
    const ref = useReveal();

    return (
        <section
            id="about"
            data-testid="about-section"
            className="bg-white py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div ref={ref} className="reveal grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    {/* Image column */}
                    <div className="lg:col-span-6 order-2 lg:order-1 relative">
                        <div className="relative aspect-[4/5] overflow-hidden">
                            <img
                                src={IMAGES.vehicle}
                                alt="CH TOURS vehicle in Sintra"
                                className="w-full h-full object-cover transition-transform duration-[1200ms] hover:scale-105"
                                data-testid="about-vehicle-image"
                            />
                            <div className="absolute inset-0 ring-1 ring-inset ring-black/5 pointer-events-none" />
                        </div>
                        {/* Gold frame accent */}
                        <div className="hidden md:block absolute -bottom-6 -right-6 h-full w-full border border-brand-gold -z-10" />
                        <div className="hidden md:flex absolute -top-6 -left-6 bg-brand-navy text-white px-6 py-5 flex-col">
                            <span className="font-serif text-4xl leading-none text-brand-gold">CH</span>
                            <span className="font-sans text-[10px] uppercase tracking-[0.4em] mt-1">Tours</span>
                        </div>
                    </div>

                    {/* Text column */}
                    <div className="lg:col-span-6 order-1 lg:order-2">
                        <p className="font-sans text-brand-gold text-xs uppercase tracking-[0.5em] mb-5">
                            — {t.about.eyebrow}
                        </p>
                        <h2
                            data-testid="about-title"
                            className="font-serif text-brand-navy text-4xl md:text-5xl lg:text-6xl leading-tight mb-8"
                        >
                            {t.about.title}
                        </h2>
                        <div className="space-y-5 font-sans text-neutral-700 leading-relaxed max-w-xl">
                            <p>{t.about.p1}</p>
                            <p>{t.about.p2}</p>
                            <p>{t.about.p3}</p>
                            <p className="text-brand-navy font-medium">{t.about.p4}</p>
                        </div>

                        <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl border-t border-neutral-200 pt-8">
                            <div>
                                <div className="font-serif text-brand-gold text-4xl md:text-5xl leading-none">
                                    5+
                                </div>
                                <div className="font-sans text-xs uppercase tracking-widest text-neutral-500 mt-2">
                                    {t.about.stat1}
                                </div>
                            </div>
                            <div>
                                <div className="font-serif text-brand-gold text-4xl md:text-5xl leading-none">
                                    1000+
                                </div>
                                <div className="font-sans text-xs uppercase tracking-widest text-neutral-500 mt-2">
                                    {t.about.stat2}
                                </div>
                            </div>
                            <div>
                                <div className="font-serif text-brand-gold text-4xl md:text-5xl leading-none">
                                    3
                                </div>
                                <div className="font-sans text-xs uppercase tracking-widest text-neutral-500 mt-2">
                                    {t.about.stat3}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
